/**
 * tabs.tsx - Sub-navegacao de tela (re-tokeniza o tabBtnStyle da semente).
 *
 * Aba ativa: borda inferior --color-accent, fundo bg-surface. Radius de
 * topo via --radius. Foco visivel via ui-base.css.
 */

import "./ui-base.css";

export interface TabItem {
  readonly id: string;
  readonly label: string;
}

export function Tabs({
  items,
  active,
  onChange,
}: {
  items: readonly TabItem[];
  active: string;
  onChange: (id: string) => void;
}) {
  return (
    <div
      role="tablist"
      style={{
        display: "flex",
        gap: "0.25rem",
        flexWrap: "wrap",
        borderBottom: "1px solid var(--color-bg-border)",
      }}
    >
      {items.map((item) => {
        const ativa = item.id === active;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={ativa}
            className="ui-focusable"
            onClick={() => { onChange(item.id); }}
            style={{
              fontFamily: '"Inter", sans-serif',
              fontSize: "0.8125rem",
              fontWeight: ativa ? 600 : 400,
              padding: "0.5rem 1rem",
              borderRadius: "var(--radius) var(--radius) 0 0",
              border: `1px solid ${ativa ? "var(--color-bg-border)" : "transparent"}`,
              borderBottom: ativa
                ? "2px solid var(--color-accent)"
                : "2px solid transparent",
              marginBottom: "-1px",
              background: ativa ? "var(--color-bg-surface)" : "transparent",
              color: ativa ? "var(--color-accent)" : "var(--color-text-muted)",
              cursor: "pointer",
              transition: "color 0.15s, background 0.15s",
            }}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
